import React from "react"

import PropTypes from "prop-types"
import {Icon} from "semantic-ui-react"

import {useSheet} from "../SheetProvider/sheetProvider"

import "./hamburgerButton.scss"

/**
 * Hamburger button.
 * Launch an action on click.
 */
const HamburgerButton = ({onClick, displayNotification}) => {
    const sheet = useSheet()
    return (
        // Button's background color is the primary color.
        <div className={sheet.classes.backgroundPrimaryColor + " hamburger-button-component"} onClick={onClick}>
            <Icon.Group>
                <Icon className="hamburger-button-component-icon" name="bars" />
                {displayNotification && (
                    <Icon className={sheet.classes.textDangerColor} corner="bottom left" name="bell" />
                )}
            </Icon.Group>
        </div>
    )
}

HamburgerButton.propTypes = {
    /**
     * Called when clicking on the button.
     */
    onClick: PropTypes.func.isRequired,
}

export default HamburgerButton
